module.exports = __webpack_public_path__ + "img/bpb_beeparktoken.9d53ea0.png";